export default {
  state: {
    lyft: {
      show: false,
      services: [],
      originalFare: 0
    },
    venue: {
      show: false,
      list: [],
      lastCoords: '',
      origPickupData: {},
      selected: {
        service: '',
        zone: '',
        location: ''
      }
    },
  },
  mutations: {
    setLyftData (state, data) {
      for (let field in data) {
        state.lyft[field] = data[field]
      }
    },
    setLyftServiceData (state, data) {
      let i = state.lyft.services.findIndex(x => x.name === data.name)
      if (i > -1) {
        state.lyft.services[i] = {...state.lyft.services[i], ...data.data}
      }
    },
    setVenueData (state, data) {
      for (let field in data) {
        state.venue[field] = data[field]
      }
    },
    addVenueList (state, data) {
      state.venue.list.push(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/dispatch/lyft.js